import * as React from "react";
import { View, Text } from "react-native";
import { withTheme } from "../theming";
import IconButton from "./IconButton";
import isNumber from "lodash.isnumber";

const Stepper = _ref => {
  let {
    Icon,
    value,
    min,
    max,
    style,
    onChange,
    defaultValue,
    theme: {
      colors,
      typography,
      roundness
    },
    iconSize = 24,
    iconColor = colors.strong,
    borderRadius = roundness,
    typeStyle
  } = _ref;
  const [stateValue, setStateValue] = React.useState(value || defaultValue || 0);
  React.useEffect(() => {
    if (value || value === 0) {
      onChange && onChange(stateValue);
    }
  }, [onChange, stateValue, value]);
  React.useEffect(() => {
    let newValue = value || defaultValue || 0;

    if (isNumber(max) && newValue > max) {
      newValue = max;
    }

    if (isNumber(min) && newValue < min) {
      newValue = min;
    }

    setStateValue(newValue);
  }, [defaultValue, value, min, max]);
  const handleMinus = React.useCallback(() => {
    if (isNumber(min) && value === min) {
      return;
    }

    setStateValue(stateValue - 1);
  }, [min, stateValue, value]);
  const handlePlus = React.useCallback(() => {
    if (isNumber(max) && value === max) {
      return;
    }

    setStateValue(stateValue + 1);
  }, [max, stateValue, value]);
  return /*#__PURE__*/React.createElement(View, {
    style: [{
      flexDirection: "row"
    }, style, borderRadius ? {
      borderRadius
    } : {}]
  }, /*#__PURE__*/React.createElement(IconButton, {
    Icon: Icon,
    icon: "MaterialIcons/remove",
    onPress: handleMinus,
    size: iconSize,
    color: iconColor,
    disabled: stateValue === min,
    style: stateValue === min ? {
      opacity: 0.5
    } : {}
  }), /*#__PURE__*/React.createElement(Text, {
    style: [typography.body1, {
      textAlign: "center",
      alignSelf: "center",
      color: colors.medium,
      marginHorizontal: 8
    }, typeStyle]
  }, value || stateValue), /*#__PURE__*/React.createElement(IconButton, {
    Icon: Icon,
    icon: "MaterialIcons/add",
    onPress: handlePlus,
    size: iconSize,
    color: iconColor,
    disabled: stateValue === max,
    style: stateValue === max ? {
      opacity: 0.5
    } : {}
  }));
};

export default withTheme(Stepper);
//# sourceMappingURL=Stepper.js.map